import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import Vowels  from './hangul/Vowels';
import HangulConsonants from './hangul/Consonants';

// 'hangul_vowels' というIDを持つ要素に 'AnotherComponent' コンポーネントをマウント
// ここでは 'App' の代わりに別のコンポーネントを使うことを示していますが、
// 同じ 'App' コンポーネントでも問題ありません。
const hangulVowelsRoot = ReactDOM.createRoot(document.getElementById('hangul_vowels'));
hangulVowelsRoot.render(
  <React.StrictMode>
    <Vowels />
  </React.StrictMode>
);

const hangulConsonantsRoot = ReactDOM.createRoot(document.getElementById('hangul_consonants'));
hangulConsonantsRoot.render(
  <React.StrictMode>
    <HangulConsonants />
  </React.StrictMode>
);

reportWebVitals();
